<template>
  <div class="">
    <el-dialog :visible="visible" title="资料查看" :close-on-click-modal="false" :before-close="close" top="5vh" width="70%" append-to-body class="file-dialog">
      <div class="file-con">
        <div :class="['file-box', fileType === 'image' ? 'file-img-box' : '']">
          <VueOfficePdf v-if="fileType === 'pdf'" :src="textVisibleURl" />
          <VueOfficeDocx v-else-if="fileType === 'docx'" :src="textVisibleURl" />
          <img v-else-if="fileType === 'image'" class="file-img" :src="textVisibleURl" alt="" />
          <video v-else-if="fileType === 'video'" :width="props.width" :height="props.height" :src="textVisibleURl" controls="controls" controlslist="nodownload"></video>
          <div v-else>不支持的文件类型</div>
        </div>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="close">关闭</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import VueOfficePdf from "@vue-office/pdf";
import VueOfficeDocx from "@vue-office/docx";
export default {
  components: { VueOfficePdf, VueOfficeDocx },
  data() {
    return {
      loading: true,
      fileType: '',
      textVisibleURl: '',
      visible: false,
    }
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
      required: true,
    },
    file: {
      type: Object,
      default: () => {
        return {
          url: null,
          name: null,
        };
      },
    },
  },
  watch: {
    showModal: {
      deep: true,
      immediate: true,
      handler(newObj, oldObj) {
        this.visible = newObj
      }
    }
  },
  methods: {
    close() {
      this.visible = false;
      this.$emit("close", this.visible);
    },
    checkFileType() {
      if (/\.(pdf)$/i.test(this.file.name)) {
        this.textVisibleURl = this.file.url;
        this.fileType = "pdf";
        //某些格式是可以直接预览的，自己测试吧
      } else if (/\.(doc|docx)$/i.test(this.file.name)) {
        this.textVisibleURl = this.file.url;
        this.fileType = "docx";
      } else if (/\.(jpg|jpeg|png|gif)$/i.test(this.file.name)) {
        this.textVisibleURl = this.file.url;
        this.fileType = "image";
      } else if (/\.(mp4|avi|rmvb|rm|flv|wmv|mpeg|mpg)$/i.test(this.file.name)) {
        this.textVisibleURl = this.file.url;
        this.fileType = "video";
      }
    },
  },
  mounted() {
    this.visible = this.showModal;
    this.checkFileType();
  }
}
</script>

<style lang="less" scoped>
.file-dialog {
  border-radius: 8px !important;
}

.file-con {
  padding: 20px;
  height: 60vh;
  overflow-y: auto;

  .file-box {
    border: 0.5px solid #eeeeee;
  }

  .file-img-box {
    height: 500px;
    overflow-y: auto;

    .file-img {
      width: 100%;
      height: auto;
    }
  }
}

.dialog-footer {
  padding: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/base/FilePreview.vue